export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js');

        registration.update().catch(() => { /* intentionally silent: best-effort side-effect */ });

        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update().catch(() => { /* intentionally silent: best-effort side-effect */ });
          }
        });

        // INC-2026-05-10: Removed window.location.reload() from controllerchange.
        // The old behaviour called reload() on every deployment — new SW installs,
        // skipWaiting() fires, clients.claim() fires, controllerchange fires, page
        // reloads mid-session for every open tab. Instead we notify the UI so it
        // can show a non-disruptive "New version available" banner. The new SW
        // already controls the page via clients.claim(), so new fetch requests use
        // fresh assets immediately without any reload.
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          window.dispatchEvent(new CustomEvent('sw-update-available'));
        });

        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data?.type === 'SYNC_COMPLETE') {
            window.dispatchEvent(new CustomEvent('sw-sync-complete', {
              detail: { synced: event.data.count }
            }));
          }
        });
      } catch (error) {
        console.log('SW registration failed:', error);
      }
    });
  }
}
